/**
 * Split a suggestion into the part the user already typed and the completion, so the row can
 * de-emphasise what they know and emphasise what is new.
 *
 * Prefix-only on purpose: suggestions come back from a prefix search, and the service tolerates one
 * typo — when the prefix does not literally match (`salontafle` → `salontafel`) nothing is
 * highlighted, which is honest rather than pretending to know which letters matched.
 */
export const splitOnTypedPrefix = (text: string, term: string) => {
  const typed = term.trim();

  if (!typed || !text.toLowerCase().startsWith(typed.toLowerCase())) {
    return { typed: "", completion: text };
  }

  return {
    typed: text.slice(0, typed.length),
    completion: text.slice(typed.length),
  };
};
